module.exports = __webpack_public_path__ + "images/iphone/search_bar_full.png";